import { reactive } from 'vue'  // 导入 reactive
import mitt from 'mitt'  // 需先安装 npm install mitt
const chat = {
  install(app, options = {}) {
      // 1. 创建事件总线
    const emitter = mitt()
    // 默认配置项
    const defaultConfig = {
      // WebSocket服务器地址，默认本地开发环境地址
      url: 'wss://www.tuoshouwang.com:8282',
      
      // 重连间隔时间（毫秒），连接断开后等待5秒尝试重连
      reconnectInterval: 1,
      
      // 最大重试次数，超过后将停止自动重连
      maxReconnectAttempts: 200,
      
      // 是否自动连接，设置为false时需要手动调用connect()
      autoConnect: true
    };
    
    // 合并用户自定义配置和默认配置
    const config = { ...defaultConfig, ...options };
    
    // 内部状态变量
    let socket = null;                // WebSocket实例
    let reconnectAttempts = 0;        // 当前重连尝试次数
    let messageQueue = [];           // 消息发送队列（连接断开时缓存消息）
    let messageIdCounter = 0;        // 自增消息ID计数器
   const state = reactive({
      chatnum: 0,  // 响应式数据
    });       // 当前用户总的未读数量

    /* 生成消息ID */
    const generateMessageId = () => ++messageIdCounter;

    /* 核心连接方法 */
    const connect = () => {
      // 避免重复连接（如果已连接或正在连接中）
       if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onclose = null;
        socket.onerror = null;
        if (socket.readyState === WebSocket.OPEN) {
          socket.close();
        }
      }
      if (socket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(socket.readyState)) {
        return;
      }
     
      // 创建WebSocket实例
      socket = new WebSocket(config.url);
      
      /* 连接成功回调 */
      socket.onopen = () => {
        reconnectAttempts = 0;                  // 重置重连计数器
        //flushMessageQueue();                    // 发送积压的消息
        emitter.emit('chat-connected'); // 触发连接事件
      };
      
      /* 收到消息回调 */
      socket.onmessage = (event) => {
        try {
          console.log(event.data,222)
          const message = JSON.parse(event.data);
          // 触发全局消息事件，组件可以通过this.$on('chat-message')监听
          emitter.emit('chat-message', message);
          //emitter.emit('chat-message', message) // 使用mitt触发事件
        } catch (e) {
          console.error('消息解析错误:', e);
          // 触发错误事件
          emitter.emit('chat-error', {
            type: 'PARSE_ERROR',  // 错误类型：消息解析失败
            error: e              // 错误对象
          });
        }
      };
      
      /* 连接关闭回调 */
      socket.onclose = () => {
        console.log('连接关闭回调')
        emitter.emit('chat-disconnected');
        scheduleReconnect();  // 尝试自动重连
      };
      
      /* 错误处理回调 */
      socket.onerror = (error) => {
        var currentTime = new Date().getTime();
        console.error('WebSocket错误:', error+currentTime);
        // 触发错误事件
        emitter.emit('chat-error', {
          type: 'SOCKET_ERROR',  // 错误类型：连接错误
          error                  // 错误对象
        });
        socket.close();         // 确保连接关闭
      };
    };

    /* 自动重连调度器 */
    const scheduleReconnect = () => {
      // 检查是否达到最大重试次数
      if (reconnectAttempts < config.maxReconnectAttempts) {
        setTimeout(() => {
          reconnectAttempts++;  // 增加重试计数
          connect();           // 尝试重新连接
        }, config.reconnectInterval); // 等待指定间隔
      } else {
        // 触发重连失败事件
        emitter.emit('chat-reconnect-failed');
      }
    };

    /* 发送消息方法 */
    const send = (content, metadata = {}) => {
      // 构造消息对象
      const message = {
        id: generateMessageId(),  // 生成唯一ID
        timestamp: Date.now(),    // 添加时间戳
        content,                  // 消息内容
        ...metadata               // 合并元数据（如消息类型、发送者等）
      };
      console.log(message,111)
      // 如果连接已建立，立即发送
      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
        return true;
      } 
      // 否则加入发送队列
      else {
        messageQueue.push(message);
        return false;
      }
    };

    /* 清空消息队列（连接恢复时调用） */
    const flushMessageQueue = () => {
      while (messageQueue.length > 0 && socket?.readyState === WebSocket.OPEN) {
        const message = messageQueue.shift();  // 从队列取出
        socket.send(JSON.stringify(message)); // 发送消息
      }
    };

    /* 主动断开连接 */
    const disconnect = () => {
      if (socket) {
        socket.close();  // 关闭连接
      }
      messageQueue = []; // 清空消息队列
    };

    /* 获取当前连接状态 */
    const getStatus = () => {
      if (!socket) return 'DISCONNECTED';
      switch (socket.readyState) {
        case WebSocket.CONNECTING: return 'CONNECTING';
        case WebSocket.OPEN:       return 'CONNECTED';
        case WebSocket.CLOSING:    return 'DISCONNECTING';
        default:                   return 'DISCONNECTED';
      }
    };

    // 将方法挂载到Vue全局属性
    app.config.globalProperties.$chat = {
      on: emitter.on,    // 监听事件
      off: emitter.off,  // 取消监听
      connect,     // 手动连接方法
      disconnect,  // 断开连接方法
      send,        // 发送消息方法
      state,
      getStatus    // 获取连接状态方法
    };

    // 根据配置决定是否自动连接
    if (config.autoConnect) {
      connect();
    }
  }
};

export default chat;